import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AgentResponse } from '../models/agent.model';
import { ApiResponse } from '../models/parameter.model';

@Injectable({
  providedIn: 'root',
})
export class HstService {
  private readonly http = inject(HttpClient);
  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('access_token') || '';
    const host = window.location.hostname.toLowerCase();
    const domainExt = host.match(/\.(com|net)/)?.[0] || '';
    const domainStr = domainExt === '.com' ? 'com' : 'net';
    return new HttpHeaders()
      .set('Authorization', `Bearer ${token}`)
      .set('domain', domainStr)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json');
  }
  private normalizeResponse<T>(response: ApiResponse<T> | T): ApiResponse<T> {
    if (
      response &&
      typeof response === 'object' &&
      'success' in response &&
      'data' in response
    ) {
      return response as ApiResponse<T>;
    }

    return { success: true, data: response as T, error: null };
  }

  private toErrorResponse<T>(error: any): ApiResponse<T> {
    const message =
      error?.error?.message ||
      error?.message ||
      'Request failed. Please try again later.';
    const code = error?.error?.code || `${error?.status ?? 'HTTP_ERROR'}`;
    return { success: false, data: null, error: { code, message } };
  }


  getUserAgentList(userId: string): Observable<ApiResponse<AgentResponse>> {
    const url =
      '/hst/user-agent-list';
    return this.http
      .post<AgentResponse>(url, { userId: userId }, { headers: this.getHeaders() })
      .pipe(
        map((response) => this.normalizeResponse<AgentResponse>(response)),
        catchError((error) => of(this.toErrorResponse<AgentResponse>(error)))
      );
  }
}
